// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3475":"7637d8a5a5061e2d","3934":"3779812274d66af8"}[chunkId] + ".css";
};